import { DataBean } from "../DataBean";

export class MarketPlacePrice extends DataBean {


    public async getMarketPlacePriceListCatalog(idMarketPlace: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getMarketPlacePriceListCatalog_Number", [idMarketPlace]);
    }
    public async deleteMarketPlacePriceList(idMarketPlacePriceList: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteMarketPlacePriceList_Number", [idMarketPlacePriceList]);
    }

    public async addPriceListToMarketPlace(idPriceList: any, fromDate: any, idMarketPlace: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.MarketPlacePriceList_addPriceListToMarketPlace_Number_java.util.Date_Number", [idPriceList, fromDate, idMarketPlace]);
    }

}